import { render, staticRenderFns } from "./ChanceLeft.vue?vue&type=template&id=31485da4&scoped=true"
import script from "./ChanceLeft.vue?vue&type=script&lang=js"
export * from "./ChanceLeft.vue?vue&type=script&lang=js"
import style0 from "./ChanceLeft.vue?vue&type=style&index=0&id=31485da4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31485da4",
  null
  
)

export default component.exports